import LegacyUpsell from 'components/LegacyUpsell';
import useExperiment from 'hooks/useExperiment';
import PlusUpsell from 'components/PlusUpsell';

export default function Upsell() {
  const experiment = useExperiment('web-growth-post-signup-upsell');

  return experiment.value === 'new_pro_modal' ? <PlusUpsell /> : <LegacyUpsell />;
}
